import React from 'react'
import "./../styles/article.css";

const CollegeConnection = () => {
    return (
        <div className="card">
            <div className="Home__container">
                <div className="article-border">
                    <div className="article-container">
                        <h1 className='article-mainheading'>The College Connection:
                            Schools with Show Choir Programs and Opportunities</h1>


                        <div className='paragraphwimage-large'>
                            <div className='imagewborder'>
                                <img src='images/article15/1.jpg' alt='Singing Hoosiers' />
                                <h2>The Singing Hoosiers</h2>
                                <h2>Indiana University</h2>
                            </div>

                            <p> High school show choir is more than just an
                                extracurricular activity—it's an experience that
                                prepares students for success both in and out
                                of the classroom. Combining vocal
                                performance, choreography, and stage
                                presence, show choir helps students develop
                                skills like teamwork, leadership, and time
                                management. These attributes make show
                                choir participants stand out in the college
                                admission process, while also opening doors
                                to scholarship opportunities and collegiate
                                performance ensembles. Across the United States, numerous colleges and
                                universities recognize the value of show choir experience and offer programs that
                                welcome students from all majors. These programs not only provide opportunities
                                for talented performers but also create a vibrant, inclusive community on campus.</p>
                        </div>

                        <h2 className='sub-head'>Schools with Notable Show Choir Ensembles</h2>
                        <p className='mb-20'>The following institutions boast some of the most dynamic and celebrated
                            collegiate show choir programs:</p>


                        <p className='mb-10'><span className='sub-head'>Ball State University (Muncie, IN): </span>Known for its University Singers, a
                            high-energy vocal and performance ensemble.</p>

                        <p className='mb-10'><span className='sub-head'>University of Nebraska–Lincoln (Lincoln, NE): </span>Features the Big Red Singers, a
                            collegiate show choir that showcases vocal and choreography excellence.</p>

                        <p className='mb-10'><span className='sub-head'>University of Nebraska–Kearney (Kearney, NE): </span>Home to the Nebraskats, a
                            celebrated show choir ensemble.</p>

                        <p className='mb-10'><span className='sub-head'>Western Nebraska Community College (Scottsbluff, NE): </span>Hosts Varsity
                            Vocalise, a versatile and engaging vocal performance group.</p>

                        <p className='mb-10'><span className='sub-head'>University of Texas at Austin (Austin, TX): </span>Features the Longhorn Singers,
                            blending choral music with performance artistry.</p>

                        <p className='mb-10'><span className='sub-head'>University of Wisconsin Colleges (Madison, WI): </span>Hosts The Wisconsin Singers,
                            known for their vibrant and polished performances.</p>

                        <p className='mb-10'><span className='sub-head'>Viterbo University (La Crosse, WI): </span>Offers two show choirs: Platinum Edition and
                            Diamond Edition, both highly regarded in the field.</p>

                        <p className='mb-10'><span className='sub-head'>Indiana University Bloomington (Bloomington, IN): </span>Home to The Singing
                            Hoosiers, one of the nation’s premier collegiate show choirs.</p>

                        <p className='mb-10'><span className='sub-head'>Jacksonville State University (Jacksonville, AL): </span>Features Encore!, a dynamic
                            and engaging vocal ensemble.</p>

                        <p className='mb-10'><span className='sub-head'>Macomb Community College (Warren, MI): </span>Known for The Macombers, a
                            celebrated group that combines vocals with choreography.</p>

                        <p className='mb-10'><span className='sub-head'>North Central College (Naperville, IL): </span>Hosts NCC Express, a lively show choir
                            ensemble blending strong vocals and movement.</p>

                        <p className='mb-10'><span className='sub-head'>Suffolk University (Boston, MA): </span>Home to Rampage, a group that combines
                            contemporary music with innovative staging.</p>

                        <p className='mb-10'><span className='sub-head'>Belmont University (Nashville, TN): </span>Hosts Company, a high-energy vocal
                            ensemble that embodies the show choir tradition.</p>

                        <p className='mb-20'><span className='sub-head'>Auburn University (Auburn, AL): </span>Hosts Auburn Singers, a dynamic show choir
                            known for its engaging performances</p>


                        <h2 className='sub-head'>Scholarship Opportunities</h2>
                        <p className='mb-20'> Many colleges and universities offer scholarships specifically for students with
                            show choir experience. These scholarships are often awarded through auditions
                            and are available to students of any major. Notable examples include:</p>


                        <p className='mb-10'><span className='sub-head'>Randolph-Macon College (Ashland, VA): </span>Offers a $1,000 annual scholarship for
                            show choir participants.</p>
                        <p className='mb-10'><span className='sub-head'>McKendree University (Lebanon, IL): </span>Provides show choir scholarships through
                            competitive auditions.</p>
                        <p className='mb-20'><span className='sub-head'>Chipola College (Marianna, FL): </span>Awards scholarships to students who excel in
                            their show choir auditions.</p>



                        <p className='mb-20'> These opportunities highlight the recognition and value that institutions place on
                            the skills and dedication cultivated in show choir.</p>


                        <h2 className='sub-head'>What Makes Show Choir Members Stand Out to College Admission Officers</h2>
                        <p className='mb-20'>Show choir participants possess a unique blend of skills and qualities that resonate
                            strongly with admissions committees:</p>



                        <div className='paragraphwimage-left-large'>
                            <div className='imagewborder-left'>
                                <img src='images/article15/2.jpg' />
                                <h2>Diamond Edition</h2>
                                <h2>Viterbo University</h2>
                            </div>
                            <p className='mb-10'><span className='sub-head'>Commitment, Discipline, and Time
                                Management:</span>Balancing long rehearsals,
                                performances, and academic
                                responsibilities demonstrates the ability to
                                manage time effectively while remaining
                                committed to rigorous activities.</p>

                            <p className='mb-10'><span className='sub-head'>Leadership and Teamwork: </span>Show choir
                                participants often take on leadership roles,
                                such as section leaders or choreographers,
                                while also learning to collaborate effectively
                                with peers. These experiences translate directly into success in college group
                                projects and organizations.</p>

                            <p><span className='sub-head'>Creativity and Artistic Expression: </span>By combining music, dance, and theatrics,
                                show choir encourages creative thinking and performance confidence. These traits
                                differentiate applicants in a pool of equally strong candidates.</p>
                        </div>

                        <p className='mb-20'>Admissions officers also appreciate the broader contributions that show choir
                            students bring to campus life:</p>


                        <p className='mb-10'><span className='sub-head'>Well-Roundedness: </span>Show choir highlights a student’s ability to excel both
                            academically and artistically.</p>
                        <p className='mb-10'><span className='sub-head'>Dedication to the Arts: </span>Even for non-music majors, show choir reflects a passion
                            for cultural engagement and creativity.</p>
                        <p className='mb-20'><span className='sub-head'>Campus Enrichment: </span>Show choir alumni often join collegiate ensembles or
                            theater productions, enriching the overall vibrancy of the college community.</p>

                        <h2 className='sub-head'>Encouragement for Aspiring Students</h2>
                        <div className='paragraphwimage-large'>

                            <div className='imagewborder'>
                                <img src='images/article15/3.jpg' alt='Singing Hoosiers' />
                                <h2>Auburn Singers</h2>
                                <h2>Auburn University</h2>
                            </div>


                            <p> Show choir is more than an activity; it’s a foundation for personal growth and
                                academic success. Whether a student dreams of pursuing a career in the
                                performing arts or another field, the skills gained from show choir—leadership,
                                discipline, creativity, and teamwork—will serve them well.
                                Colleges across the nation are eager to
                                welcome students with show choir
                                experience, offering scholarships and
                                opportunities to participate in vibrant
                                performance ensembles. With the stage set
                                for success, show choir students have the
                                tools to shine in college and beyond.
                                Whether your goal is to earn a scholarship,
                                join a collegiate show choir, or simply use
                                your talents to stand out, the experience
                                you’ve gained through show choir will help
                                you take the next step.</p>

                        </div>





                        <div className='college-connection-last'>
                            <div style={{ backgroundImage: `url('images/article15/4.jpg')` }} id='cc-img'>
                                {/* <img src='images/article15/4.jpg' /> */}
                            </div>
                            <div className='cc-2'>
                                <p className='mb-20'>
                                    Are you auditioning for a collegiate show choir, or have
                                    you already completed your audition? We’d love to hear
                                    from you!
                                </p>

                                <ul className='mb-20 hearts-list'>
                                    <li>If you’re planning to audition, let us know your
                                        name and the college or university where you’re
                                        auditioning—we’re here to cheer you on.</li>
                                    <li>If you’ve already auditioned, share your experience with us!
                                        Your insights could be helpful to others who are preparing for
                                        this exciting journey.</li>
                                    <li>And if you’ve been selected for a collegiate show choir for
                                        the upcoming year, congratulations! We want to celebrate
                                        this amazing achievement with you. Share your name, high
                                        school, and the collegiate show choir you’ll be a part of.</li>
                                </ul>

                                <p>Join the conversation and connect with other performers
                                    on the <a href='https://www.facebook.com/profile.php?id=61571698236116' target='_blank'>BetweenChoirs Facebook page</a> under “The
                                    College Connection.” We can’t wait to hear from you
                                    and celebrate your successes!</p>

                            </div>
                        </div>












                    </div>

                    <div className='article-ad'>
                        <a href='https://www.accoladi.com/' target='_blank'>
                            <img src='images/accoladi-add.jpg' />
                        </a>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default CollegeConnection